module.exports = __webpack_public_path__ + "img/Instagram.26b65b3c.png";